<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">実績履歴</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="block-row">
          <div class="column-list">
            <label class="list-input-title">Ｐコード</label>
            <div class="list-input-content" style="width: 7rem;">
              <select id="cmb_PCodeList" #cmb_PCodeList labelField="PCode" [(ngModel)]="kymw0800Model.pCode"
                forcedEnabledMode="true" (change)="eventPCodeList_ChangedHandler(null)" [tabindex]="0">
                <ng-template ngFor let-item [ngForOf]="kymw0800Model.pCodeList">
                  <option value="{{item.PCode}}">{{item.PCode}}</option>
                </ng-template>
              </select>
            </div>
          </div>
          <div class="column-list">
            <label class="list-input-title">商品名</label>
            <div class="list-input-content" style="width: 36rem;">
              <input type="text" id="lbl_GuideGoodsName" class="guide-goods-name"
                value="{{kymw0800Model.guideGoodsName}}" readonly>
            </div>
          </div>
          <div class="column-list">
            <label class="list-input-title">規格名</label>
            <div class="list-input-content">
              <input type="text" id="lbl_GuidsStandardName" class="guide-standard-name"
                value="{{kymw0800Model.guideStandardName}}" readonly>
            </div>
          </div>
        </div>
        <div>
          <div class="grid-container">
            <div class="action-area">
              <div class="guide-label">
                <label class="lbl_Multi">多重掲載有り</label>
              </div>
              <app-checkbox-label label="詳細表示" id="chk_ResultDetail" [subid]="'chk_ResultDetail'"
                [forcedEnabledMode]="'true'" [(ngModel)]="kymw0800Model.resultDetail"
                (change)="eventResultDetail_CheckHandler(null)" [tabindex]="0">
              </app-checkbox-label>
              <app-pager [prevDisabled]="kymw0800Model.prevPageDisabled" [nextDisabled]="kymw0800Model.nextPageDisabled"
                [totalNum]="kymw0800Model.totalNum" [startNum]="kymw0800Model.startDispNum"
                [endNum]="kymw0800Model.endDispNum" (prevHandler)="eventBack_ClickHandler(null)"
                (nextHandler)="eventNext_ClickHandler(null)">
              </app-pager>
            </div>

            <!-- データグリッド定義(実績履歴一覧) -->
            <wj-flex-grid #dtg_ResultList id="dtg_ResultList" [itemsSource]="kymw0800Model.resultList"
              forcedEnabledMode="true" headerStyleName="headerStyle" liveScrolling="false" allowMultipleSelection="true"
              draggableColumns="false" textAlign="center" lockedColumnCount="4" [frozenColumns]="4" [isReadOnly]="true"
              [allowSorting]="false" [deferResizing]="true" [headersVisibility]="'Column'" [allowDragging]="'None'"
              [selectionMode]="'ListBox'" (click)="eventResultList_HeaderHandler($event,dtg_ResultList)" [tabindex]="0">
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]="'受注コード'" [multiLine]="true"
                [binding]="'OrderCode'" id="dtg_OrderCode" #dtg_OrderCode></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]="'配達企画回'" [multiLine]="true"
                [binding]="'DelivCatalogId'" id="dtg_DelivCatlogId" #dtg_DelivCatlogId>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'媒体'" [multiLine]="true"
                [binding]="'MediumName'" id="dtg_MediumName" #dtg_MediumName></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]="'Ｐコード'" [multiLine]="true" [binding]="'PCode'"
                id="dtg_Pcode" #dtg_Pcode></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="125" [header]="'計画数'" [multiLine]="true" [align]="'right'"
                [binding]="'PlanNumTotal'" id="dtg_PlanNumTotal" #dtg_PlanNumTotal sortable="false">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.PlanNumTotal">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="125" [header]="'実績数'" [multiLine]="true" [align]="'right'"
                [binding]="'ResultNumTotal'" id="dtg_ResultNumTotal" #dtg_ResultNumTotal sortable="false">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ResultNumTotal">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="125" [header]=HEAD_TEXT [multiLine]="true" [align]="'right'"
                [binding]="'ResultPriceTotal'" id="dtg_ResultPriceTotal" #dtg_ResultPriceTotal sortable="false">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ResultPriceTotal">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="125" [header]="'点数ＰＩ'" [multiLine]="true" [align]="'right'"
                [binding]="'ResultPiTotal'" id="dtg_ResultPiTotal" #dtg_ResultPiTotal sortable="false">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <label [style.position]="'relative'">{{cell.item.ResultPiTotal}}</label>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 取扱生協 -->
              <wj-flex-grid-column [minWidth]="5" [width]="65" [header]="'い'" [multiLine]="true" [binding]="'Coop1'"
                [align]="'right'" id="dtg_HandlingCoop1" #dtg_HandlingCoop1 sortable="false">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div [wjTooltip]="cell.item.Coop1.replace('◎', '')"
                    [class.lbl_Multi]="cell.item.Coop1.indexOf('◎') !== -1">
                    <label>{{cell.item.Coop1.replace('◎', '')}}</label>
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="65" [header]="'と'" [multiLine]="true" [binding]="'Coop2'"
                [align]="'right'" id="dtg_HandlingCoop2" #dtg_HandlingCoop2 sortable="false">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div [wjTooltip]="cell.item.Coop2.replace('◎', '')"
                    [class.lbl_Multi]="cell.item.Coop2.indexOf('◎') !== -1">
                    <label>{{cell.item.Coop2.replace('◎', '')}}</label>
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="65" [header]="'ぐ'" [multiLine]="true" [binding]="'Coop3'"
                [align]="'right'" id="dtg_HandlingCoop3" #dtg_HandlingCoop3 sortable="false">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div [wjTooltip]="cell.item.Coop3.replace('◎', '')"
                    [class.lbl_Multi]="cell.item.Coop3.indexOf('◎') !== -1">
                    <label>{{cell.item.Coop3.replace('◎', '')}}</label>
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="65" [header]="'ち'" [multiLine]="true" [binding]="'Coop4'"
                [align]="'right'" id="dtg_HandlingCoop4" #dtg_HandlingCoop4 sortable="false">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div [wjTooltip]="cell.item.Coop4.replace('◎', '')"
                    [class.lbl_Multi]="cell.item.Coop4.indexOf('◎') !== -1">
                    <label>{{cell.item.Coop4.replace('◎', '')}}</label>
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="65" [header]="'さ'" [multiLine]="true" [binding]="'Coop5'"
                [align]="'right'" id="dtg_HandlingCoop5" #dtg_HandlingCoop5 sortable="false">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div [wjTooltip]="cell.item.Coop5.replace('◎', '')"
                    [class.lbl_Multi]="cell.item.Coop5.indexOf('◎') !== -1">
                    <label>{{cell.item.Coop5.replace('◎', '')}}</label>
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="65" [header]="'とう'" [multiLine]="true" [binding]="'Coop6'"
                [align]="'right'" id="dtg_HandlingCoop6" #dtg_HandlingCoop6 sortable="false">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div [wjTooltip]="cell.item.Coop6.replace('◎', '')"
                    [class.lbl_Multi]="cell.item.Coop6.indexOf('◎') !== -1">
                    <label>{{cell.item.Coop6.replace('◎', '')}}</label>
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="65" [header]="'な'" [multiLine]="true" [binding]="'Coop7'"
                [align]="'right'" id="dtg_HandlingCoop7" #dtg_HandlingCoop7 sortable="false">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div [wjTooltip]="cell.item.Coop7.replace('◎', '')"
                    [class.lbl_Multi]="cell.item.Coop7.indexOf('◎') !== -1">
                    <label>{{cell.item.Coop7.replace('◎', '')}}</label>
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="65" [header]="'に'" [multiLine]="true" [binding]="'Coop8'"
                [align]="'right'" id="dtg_HandlingCoop8" #dtg_HandlingCoop8 sortable="false">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div [wjTooltip]="cell.item.Coop8.replace('◎', '')"
                    [class.lbl_Multi]="cell.item.Coop8.indexOf('◎') !== -1">
                    <label>{{cell.item.Coop8.replace('◎', '')}}</label>
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- ダミー列 -->
              <wj-flex-grid-column [minWidth]="5" [width]="'*'" [header]="' '" [multiLine]="true" [binding]="'Dummy'"
                id="dtg_Dummy" #dtg_Dummy sortable="false" [visible]="false">
              </wj-flex-grid-column>
              <!-- いばらき -->
              <!-- 企画回 -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_I_01 [multiLine]="true"
                [binding]="'DelivCatalogId1'" id="dtg_DetailI0" sortable="false" #dtg_DetailI0>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_I2_01>{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 供給価 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_I_02 [multiLine]="true"
                [align]="'right'" [binding]="'ThisTimeSupplyTaxWithout1'" id="dtg_DetailI1" sortable="false"
                #dtg_DetailI1>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_I2_02>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ThisTimeSupplyTaxWithout1">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 単仕入価 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_I_03 [multiLine]="true"
                [align]="'right'" [binding]="'ThisTimeCostPrice1'" id="dtg_DetailI2" sortable="false" #dtg_DetailI2>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_I2_03>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ThisTimeCostPrice1">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- ページ -->
              <wj-flex-grid-column [minWidth]="5" [width]="60" [header]=HEAD_TEXT_I_04 [multiLine]="true"
                [align]="'left'" [binding]="'PageNum1'" id="dtg_DetailI3" sortable="false" #dtg_DetailI3>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <button class="link-button" [style.font-weight]="'bold'"
                    (click)="clickPdfLinkButton(cell.item, 'PageNum1')" [tabindex]="-1">{{cell.item.PageNum1}}</button>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 枠数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="60" [header]=HEAD_TEXT_I_05 [multiLine]="true"
                [binding]="'PublishAmountLimitNum1'" id="dtg_DetailI4" sortable="false" #dtg_DetailI4 [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_I2_05>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  {{cell.item.PublishAmountLimitNum1}}
                </ng-template>
              </wj-flex-grid-column>
              <!-- 価格パターン -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_I_06 [multiLine]="true"
                [binding]="'PricePatternName1'" textAlign="left" id="dtg_DetailI5" sortable="false" #dtg_DetailI5>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 登場区分 -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_I_07 [multiLine]="true"
                [binding]="'AppearDivName1'" textAlign="left" id="dtg_DetailI6" sortable="false" #dtg_DetailI6>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 計画数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_I_08 [multiLine]="true"
                [align]="'right'" [binding]="'PlanNum1'" id="dtg_DetailI7" sortable="false" #dtg_DetailI7>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.PlanNum1">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 実績数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_I_09 [multiLine]="true"
                [align]="'right'" [binding]="'ResultsNum1'" id="dtg_DetailI8" sortable="false" #dtg_DetailI8>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ResultsNum1">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 実績額 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_I_10 [multiLine]="true"
                [align]="'right'" [binding]="'ResultsAmount1'" id="dtg_DetailI9" sortable="false" #dtg_DetailI9>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_I2_10>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ResultsAmount1">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- とちぎ -->
              <!-- 企画回 -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_TO_01 [multiLine]="true"
                [binding]="'DelivCatalogId2'" id="dtg_DetailT0" sortable="false" #dtg_DetailT0>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_TO2_01>{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 供給価 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_TO_02 [multiLine]="true"
                [align]="'right'" [binding]="'ThisTimeSupplyTaxWithout2'" id="dtg_DetailT1" sortable="false"
                #dtg_DetailT1>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_TO2_02>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ThisTimeSupplyTaxWithout2">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 単仕入価 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_TO_03 [multiLine]="true"
                [align]="'right'" [binding]="'ThisTimeCostPrice2'" id="dtg_DetailT2" sortable="false" #dtg_DetailT2>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_TO2_03>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ThisTimeCostPrice2">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- ページ -->
              <wj-flex-grid-column [minWidth]="5" [width]="60" [header]=HEAD_TEXT_TO_04 [multiLine]="true"
                [align]="'left'" [binding]="'PageNum2'" id="dtg_DetailT3" sortable="false" #dtg_DetailT3>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <button class="link-button" [style.font-weight]="'bold'"
                    (click)="clickPdfLinkButton(cell.item, 'PageNum2')" [tabindex]="-1">{{cell.item.PageNum2}}</button>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 枠数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="60" [header]=HEAD_TEXT_TO_05 [multiLine]="true"
                [binding]="'PublishAmountLimitNum2'" id="dtg_DetailT4" sortable="false" #dtg_DetailT4 [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_TO2_05>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  {{cell.item.PublishAmountLimitNum2}}
                </ng-template>
              </wj-flex-grid-column>
              <!-- 価格パターン -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_TO_06 [multiLine]="true"
                [binding]="'PricePatternName2'" textAlign="left" id="dtg_DetailT5" sortable="false" #dtg_DetailT5>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 登場区分 -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_TO_07 [multiLine]="true"
                [binding]="'AppearDivName2'" textAlign="left" id="dtg_DetailT6" sortable="false" #dtg_DetailT6>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 計画数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_TO_08 [multiLine]="true"
                [align]="'right'" [binding]="'PlanNum2'" id="dtg_DetailT7" sortable="false" #dtg_DetailT7>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.PlanNum2">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 実績数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_TO_09 [multiLine]="true"
                [align]="'right'" [binding]="'ResultsNum2'" id="dtg_DetailT8" sortable="false" #dtg_DetailT8>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ResultsNum2">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 実績額 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_TO_10 [multiLine]="true"
                [align]="'right'" [binding]="'ResultsAmount2'" id="dtg_DetailT9" sortable="false" #dtg_DetailT9>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_TO2_10>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ResultsAmount2">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- ぐんま -->
              <!-- 企画回 -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_GU_01 [multiLine]="true"
                [binding]="'DelivCatalogId3'" id="dtg_DetailG0" sortable="false" #dtg_DetailG0>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_GU2_01>{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 供給価 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_GU_02 [multiLine]="true"
                [align]="'right'" [binding]="'ThisTimeSupplyTaxWithout3'" id="dtg_DetailG1" sortable="false"
                #dtg_DetailG1>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_GU2_02>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ThisTimeSupplyTaxWithout3">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 単仕入価 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_GU_03 [multiLine]="true"
                [align]="'right'" [binding]="'ThisTimeCostPrice3'" id="dtg_DetailG2" sortable="false" #dtg_DetailG2>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_GU2_03>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ThisTimeCostPrice3">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- ページ -->
              <wj-flex-grid-column [minWidth]="5" [width]="60" [header]=HEAD_TEXT_GU_04 [multiLine]="true"
                [align]="'left'" [binding]="'PageNum3'" id="dtg_DetailG3" sortable="false" #dtg_DetailG3>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <button class="link-button" [style.font-weight]="'bold'"
                    (click)="clickPdfLinkButton(cell.item, 'PageNum3')" [tabindex]="-1">{{cell.item.PageNum3}}</button>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 枠数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="60" [header]=HEAD_TEXT_GU_05 [multiLine]="true"
                [binding]="'PublishAmountLimitNum3'" id="dtg_DetailG4" sortable="false" #dtg_DetailG4 [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_GU2_05>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  {{cell.item.PublishAmountLimitNum3}}
                </ng-template>
              </wj-flex-grid-column>
              <!-- 価格パターン -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_GU_06 [multiLine]="true"
                [binding]="'PricePatternName3'" textAlign="left" id="dtg_DetailG5" sortable="false" #dtg_DetailG5>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 登場区分 -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_GU_07 [multiLine]="true"
                [binding]="'AppearDivName3'" textAlign="left" id="dtg_DetailG6" sortable="false" #dtg_DetailG6>
              </wj-flex-grid-column>
              <!-- 計画数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_GU_08 [multiLine]="true"
                [align]="'right'" [binding]="'PlanNum3'" id="dtg_DetailG7" sortable="false" #dtg_DetailG7>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.PlanNum3">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 実績数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_GU_09 [multiLine]="true"
                [align]="'right'" [binding]="'ResultsNum3'" id="dtg_DetailG8" sortable="false" #dtg_DetailG8>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ResultsNum3">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 実績額 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_GU_10 [multiLine]="true"
                [align]="'right'" [binding]="'ResultsAmount3'" id="dtg_DetailG9" sortable="false" #dtg_DetailG9>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_GU2_10>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ResultsAmount3">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- ちば -->
              <!-- 企画回 -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_TI_01 [multiLine]="true"
                [binding]="'DelivCatalogId4'" id="dtg_DetailC0" sortable="false" #dtg_DetailC0>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_TI2_01>{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 供給価 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_TI_02 [multiLine]="true"
                [align]="'right'" [binding]="'ThisTimeSupplyTaxWithout4'" id="dtg_DetailC1" sortable="false"
                #dtg_DetailC1>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_TI2_02>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ThisTimeSupplyTaxWithout4">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 単仕入価 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_TI_03 [multiLine]="true"
                [align]="'right'" [binding]="'ThisTimeCostPrice4'" id="dtg_DetailC2" sortable="false" #dtg_DetailC2>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_TI2_03>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ThisTimeCostPrice4">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- ページ -->
              <wj-flex-grid-column [minWidth]="5" [width]="60" [header]=HEAD_TEXT_TI_04 [multiLine]="true"
                [align]="'left'" [binding]="'PageNum4'" id="dtg_DetailC3" sortable="false" #dtg_DetailC3>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <button class="link-button" [style.font-weight]="'bold'"
                    (click)="clickPdfLinkButton(cell.item, 'PageNum4')" [tabindex]="-1">{{cell.item.PageNum4}}</button>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 枠数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="60" [header]=HEAD_TEXT_TI_05 [multiLine]="true"
                [binding]="'PublishAmountLimitNum4'" id="dtg_DetailC4" sortable="false" #dtg_DetailC4 [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_TI2_05>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  {{cell.item.PublishAmountLimitNum4}}
                </ng-template>
              </wj-flex-grid-column>
              <!-- 価格パターン -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_TI_06 [multiLine]="true"
                [binding]="'PricePatternName4'" textAlign="left" id="dtg_DetailC5" sortable="false" #dtg_DetailC5>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 登場区分 -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_TI_07 [multiLine]="true"
                [binding]="'AppearDivName4'" textAlign="left" id="dtg_DetailC6" sortable="false" #dtg_DetailC6>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 計画数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_TI_08 [multiLine]="true"
                [align]="'right'" [binding]="'PlanNum4'" id="dtg_DetailC7" sortable="false" #dtg_DetailC7>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.PlanNum4">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 実績数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_TI_09 [multiLine]="true"
                [align]="'right'" [binding]="'ResultsNum4'" id="dtg_DetailC8" sortable="false" #dtg_DetailC8>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ResultsNum4">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 実績額 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_TI_10 [multiLine]="true"
                [align]="'right'" [binding]="'ResultsAmount4'" id="dtg_DetailC9" sortable="false" #dtg_DetailC9>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_TI2_10>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ResultsAmount4">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- さいたま -->
              <!-- 企画回 -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_SA_01 [multiLine]="true"
                [binding]="'DelivCatalogId5'" id="dtg_DetailS0" sortable="false" #dtg_DetailS0>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_SA2_01>{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 供給価 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_SA_02 [multiLine]="true"
                [align]="'right'" [binding]="'ThisTimeSupplyTaxWithout5'" id="dtg_DetailS1" sortable="false"
                #dtg_DetailS1>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_SA2_02>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ThisTimeSupplyTaxWithout5">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 単仕入価 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_SA_03 [multiLine]="true"
                [align]="'right'" [binding]="'ThisTimeCostPrice5'" id="dtg_DetailS2" sortable="false" #dtg_DetailS2>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_SA2_03>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ThisTimeCostPrice5">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- ページ -->
              <wj-flex-grid-column [minWidth]="5" [width]="60" [header]=HEAD_TEXT_SA_04 [multiLine]="true"
                [align]="'left'" [binding]="'PageNum5'" id="dtg_DetailS3" sortable="false" #dtg_DetailS3>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <button class="link-button" [style.font-weight]="'bold'"
                    (click)="clickPdfLinkButton(cell.item, 'PageNum5')" [tabindex]="-1">{{cell.item.PageNum5}}</button>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 枠数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="60" [header]=HEAD_TEXT_SA_05 [multiLine]="true"
                [binding]="'PublishAmountLimitNum5'" id="dtg_DetailS4" sortable="false" #dtg_DetailS4 [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_SA2_05>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  {{cell.item.PublishAmountLimitNum5}}
                </ng-template>
              </wj-flex-grid-column>
              <!-- 価格パターン -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_SA_06 [multiLine]="true"
                [binding]="'PricePatternName5'" textAlign="left" id="dtg_DetailS5" sortable="false" #dtg_DetailS5>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 登場区分 -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_SA_07 [multiLine]="true"
                [binding]="'AppearDivName5'" textAlign="left" id="dtg_DetailS6" sortable="false" #dtg_DetailS6>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 計画数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_SA_08 [multiLine]="true"
                [align]="'right'" [binding]="'PlanNum5'" id="dtg_DetailS7" sortable="false" #dtg_DetailS7>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.PlanNum5">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 実績数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_SA_09 [multiLine]="true"
                [align]="'right'" [binding]="'ResultsNum5'" id="dtg_DetailS8" sortable="false" #dtg_DetailS8>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ResultsNum5">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 実績額 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_SA_10 [multiLine]="true"
                [align]="'right'" [binding]="'ResultsAmount5'" id="dtg_DetailS9" sortable="false" #dtg_DetailS9>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_SA2_10>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ResultsAmount5">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- とうきょう -->
              <!-- 企画回 -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_TOU_01 [multiLine]="true"
                [binding]="'DelivCatalogId6'" id="dtg_DetailTO0" sortable="false" #dtg_DetailTO0>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_TOU2_01>{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 供給価 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_TOU_02 [multiLine]="true"
                [align]="'right'" [binding]="'ThisTimeSupplyTaxWithout6'" id="dtg_DetailTO1" sortable="false"
                #dtg_DetailTO1>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_TOU2_02>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ThisTimeSupplyTaxWithout6">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 単仕入価 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_TOU_03 [multiLine]="true"
                [align]="'right'" [binding]="'ThisTimeCostPrice6'" id="dtg_DetailTO2" sortable="false" #dtg_DetailTO2>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_TOU2_03>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ThisTimeCostPrice6">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- ページ -->
              <wj-flex-grid-column [minWidth]="5" [width]="60" [header]=HEAD_TEXT_TOU_04 [multiLine]="true"
                [align]="'left'" [binding]="'PageNum6'" id="dtg_DetailTO3" sortable="false" #dtg_DetailTO3>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <button class="link-button" [style.font-weight]="'bold'"
                    (click)="clickPdfLinkButton(cell.item, 'PageNum6')" [tabindex]="-1">{{cell.item.PageNum6}}</button>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 枠数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="60" [header]=HEAD_TEXT_TOU_05 [multiLine]="true"
                [binding]="'PublishAmountLimitNum6'" id="dtg_DetailTO4" sortable="false" #dtg_DetailTO4
                [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_TOU2_05>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  {{cell.item.PublishAmountLimitNum6}}
                </ng-template>
              </wj-flex-grid-column>
              <!-- 価格パターン -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_TOU_06 [multiLine]="true"
                [binding]="'PricePatternName6'" textAlign="left" id="dtg_DetailTO5" sortable="false" #dtg_DetailTO5>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 登場区分 -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_TOU_07 [multiLine]="true"
                [binding]="'AppearDivName6'" textAlign="left" id="dtg_DetailTO6" sortable="false" #dtg_DetailTO6>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 計画数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_TOU_08 [multiLine]="true"
                [align]="'right'" [binding]="'PlanNum6'" id="dtg_DetailTO7" sortable="false" #dtg_DetailTO7>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.PlanNum6">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 実績数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_TOU_09 [multiLine]="true"
                [align]="'right'" [binding]="'ResultsNum6'" id="dtg_DetailTO8" sortable="false" #dtg_DetailTO8>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ResultsNum6">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 実績額 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_TOU_10 [multiLine]="true"
                [align]="'right'" [binding]="'ResultsAmount6'" id="dtg_DetailTO9" sortable="false" #dtg_DetailTO9>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_TOU2_10>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ResultsAmount6">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- ながの -->
              <!-- 企画回 -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_NA_01 [multiLine]="true"
                [binding]="'DelivCatalogId7'" id="dtg_DetailNA0" sortable="false" #dtg_DetailNA0>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_NA2_01>{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 供給価 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_NA_02 [multiLine]="true"
                [align]="'right'" [binding]="'ThisTimeSupplyTaxWithout7'" id="dtg_DetailNA1" sortable="false"
                #dtg_DetailNA1>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_NA2_02>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ThisTimeSupplyTaxWithout7">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 単仕入価 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_NA_03 [multiLine]="true"
                [align]="'right'" [binding]="'ThisTimeCostPrice7'" id="dtg_DetailNA2" sortable="false" #dtg_DetailNA2>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_NA2_03>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ThisTimeCostPrice7">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- ページ -->
              <wj-flex-grid-column [minWidth]="5" [width]="60" [header]=HEAD_TEXT_NA_04 [multiLine]="true"
                [align]="'left'" [binding]="'PageNum7'" id="dtg_DetailNA3" sortable="false" #dtg_DetailNA3>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <button class="link-button" [style.font-weight]="'bold'"
                    (click)="clickPdfLinkButton(cell.item, 'PageNum7')" [tabindex]="-1">{{cell.item.PageNum7}}</button>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 枠数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="60" [header]=HEAD_TEXT_NA_05 [multiLine]="true"
                [binding]="'PublishAmountLimitNum7'" id="dtg_DetailNA4" sortable="false" #dtg_DetailNA4
                [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_NA2_05>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  {{cell.item.PublishAmountLimitNum7}}
                </ng-template>
              </wj-flex-grid-column>
              <!-- 価格パターン -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_NA_06 [multiLine]="true"
                [binding]="'PricePatternName7'" textAlign="left" id="dtg_DetailNA5" sortable="false" #dtg_DetailNA5>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 登場区分 -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_NA_07 [multiLine]="true"
                [binding]="'AppearDivName7'" textAlign="left" id="dtg_DetailNA6" sortable="false" #dtg_DetailNA6>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 計画数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_NA_08 [multiLine]="true"
                [align]="'right'" [binding]="'PlanNum7'" id="dtg_DetailNA7" sortable="false" #dtg_DetailNA7>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.PlanNum7">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 実績数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_NA_09 [multiLine]="true"
                [align]="'right'" [binding]="'ResultsNum7'" id="dtg_DetailNA8" sortable="false" #dtg_DetailNA8>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ResultsNum7">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 実績額 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_NA_10 [multiLine]="true"
                [align]="'right'" [binding]="'ResultsAmount7'" id="dtg_DetailNA9" sortable="false" #dtg_DetailNA9>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_NA2_10>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ResultsAmount7">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>

              <!-- にいがた -->
              <!-- 企画回 -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_NI_01 [multiLine]="true"
                [binding]="'DelivCatalogId8'" id="dtg_DetailN0" sortable="false" #dtg_DetailN0>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_NI2_01>{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 供給価 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_NI_02 [multiLine]="true"
                [align]="'right'" [binding]="'ThisTimeSupplyTaxWithout8'" id="dtg_DetailN1" sortable="false"
                #dtg_DetailN1>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_NI2_02>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ThisTimeSupplyTaxWithout8">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 単仕入価 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_NI_03 [multiLine]="true"
                [align]="'right'" [binding]="'ThisTimeCostPrice8'" id="dtg_DetailN2" sortable="false" #dtg_DetailN2>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_NI2_03>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ThisTimeCostPrice8">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- ページ -->
              <wj-flex-grid-column [minWidth]="5" [width]="60" [header]=HEAD_TEXT_NI_04 [multiLine]="true"
                [align]="'left'" [binding]="'PageNum8'" id="dtg_DetailN3" sortable="false" #dtg_DetailN3>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <button class="link-button" [style.font-weight]="'bold'"
                    (click)="clickPdfLinkButton(cell.item, 'PageNum8')" [tabindex]="-1">{{cell.item.PageNum8}}</button>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 枠数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="60" [header]=HEAD_TEXT_NI_05 [multiLine]="true"
                [binding]="'PublishAmountLimitNum8'" id="dtg_DetailN4" sortable="false" #dtg_DetailN4 [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_NI2_05>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  {{cell.item.PublishAmountLimitNum8}}
                </ng-template>
              </wj-flex-grid-column>
              <!-- 価格パターン -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_NI_06 [multiLine]="true"
                [binding]="'PricePatternName8'" textAlign="left" id="dtg_DetailN5" sortable="false" #dtg_DetailN5>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 登場区分 -->
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]=HEAD_TEXT_NI_07 [multiLine]="true"
                [binding]="'AppearDivName8'" textAlign="left" id="dtg_DetailN6" sortable="false" #dtg_DetailN6>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 計画数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_NI_08 [multiLine]="true"
                [align]="'right'" [binding]="'PlanNum8'" id="dtg_DetailN7" sortable="false" #dtg_DetailN7>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.PlanNum8">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 実績数 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_NI_09 [multiLine]="true"
                [align]="'right'" [binding]="'ResultsNum8'" id="dtg_DetailN8" sortable="false" #dtg_DetailN8>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]="cell.col.header">{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ResultsNum8">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
              <!-- 実績額 -->
              <wj-flex-grid-column [minWidth]="5" [width]="75" [header]=HEAD_TEXT_NI_10 [multiLine]="true"
                [align]="'right'" [binding]="'ResultsAmount8'" id="dtg_DetailN9" sortable="false" #dtg_DetailN9>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div [wjTooltip]=HEAD_TEXT_NI2_10>{{ cell.col.header }}</div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <app-comma-format [textAlign]="'right'" [Data]="cell.item.ResultsAmount8">
                  </app-comma-format>
                </ng-template>
              </wj-flex-grid-column>
            </wj-flex-grid>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Out" #btn_Out class="btn-primary" forcedEnabledMode="true"
            (click)="eventOut_ClickHandler(null)" [tabindex]="0">出力</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventClose_ClickHandler(null)"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>